import { darken, getLuminance, lighten } from '@mui/material/styles';

const ADJUST_COEFFICIENT = 0.5;
const DARK_LUMINANCE_THRESHOLD = 0.3;

// Darkening an already-dark color is barely visible, so lighten dark colors on hover instead.
export default function getHoverBorderColor(color: string) {
  return getLuminance(color) > DARK_LUMINANCE_THRESHOLD
    ? darken(color, ADJUST_COEFFICIENT)
    : lighten(color, ADJUST_COEFFICIENT);
}
